let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ipFBo")).then(() => parcelRequire('aEpcu'));